import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import useGetCourses from "../domains/courses/services/use-get-courses";
import { extractReunionCourses, getCurrentDate, getNextRace } from "../utils/format";
import { FlattedCourse } from "../domains/courses/services/type";

const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

const CountdownTimer = () => {
    const { data: program } = useGetCourses(getCurrentDate());

    const [nextRace, setNextRace] = useState<FlattedCourse | null>(null);
    const [timeLeft, setTimeLeft] = useState(0);

    // 🎯 Récupération de la prochaine course quand le programme change
    useEffect(() => {
        if (!program) return;

        const next = getNextRace(extractReunionCourses(program.reunions));
        if (next) {
            setNextRace(next);
            setTimeLeft(Math.floor((next.time - Date.now()) / 1000));
        }
    }, [program]); // Dépend uniquement de `program`

    // 🎯 Décrémente le timer chaque seconde
    useEffect(() => {
        if (timeLeft <= 0) {
            // Quand le temps atteint 0, on cherche la prochaine course
            const next = getNextRace(extractReunionCourses(program?.reunions));
            if (next) {
                setNextRace(next);
                setTimeLeft(Math.floor((next.time - Date.now()) / 1000));
            }
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer); // Nettoie le timer pour éviter plusieurs intervalles
    }, [timeLeft]); // Ne dépend que de `timeLeft`

    return (
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
            {(nextRace && timeLeft / 60 < 60) && (
                <Typography fontWeight={600} fontSize={20} color="secondary.main">
                    {`R${nextRace.course.numReunion} - C${nextRace.courseNum} : ${formatTime(timeLeft)}`}
                </Typography>
            )}
        </Box>
    );
};

export default CountdownTimer;
